import session from '../../auth_api/session'
// import Vue from 'vue'

const URL = process.env.VUE_APP_API_URL
const URLImportFile = URL + 'kindergarten_101/api/'

export default {
  namespaced: true,
  state: {
    childrenList: { 'results': [] }
  },
  mutations: {
    setChildrenList (state, payload) {
      state.childrenList = payload
    },
    setData (state, payload) {
      state.data = payload
    },
    setItem (state, payload) {
      let data = state.childrenList.results
      for (let i in data) {
        if (data[i]['id'] === payload.id) {
          Object.assign(data[i], payload)
          break
        }
      }
    }
  },
  actions: {
    updateData ({ commit }, payload) {
      return session.put(URL + 'kindergarten_101/api/reestrchildren/' + payload.item.id + '/', payload.item)
    },
    fetchChildrenList ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', 'fetchChildrenList', { root: true })
        let params = {}
        params['reestr'] = payload.reestr
        if (0 + payload.pageId > 1) {
          params['page'] = payload.pageId
        }

        let _url = URLImportFile + 'reestrchildren/'
        session.get(_url, { params: params })
          .then(response => {
            commit('setChildrenList', response.data)
            commit('common/popLoading', 'fetchChildrenList', { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', 'fetchChildrenList', { root: true })
            reject(e)
          })
      })
    }
  },
  getters: {
    childrenList (state) {
      return state.childrenList
    }
  }
}
